// extracted by mini-css-extract-plugin
module.exports = {"c-new-on-cian-title":"_025a50318d--c-new-on-cian-title--1AmP5","c-new-on-cian-link-item":"_025a50318d--c-new-on-cian-link-item--EaPGr"};